<div class="password-reset-modal">
  <ng-container *ngIf="showResponse && passwordResetMessage; else passwordTokenForm">
    <header class="modal__header">
      <h2>{{ passwordResetMessage.title }}</h2>
      <a class="button button--transparent modal__button--close" (click)="closeModal(true)">
        <i class="icon icon-ui-close--sm"></i>
      </a>
    </header>
    <div class="modal__content">
      <div [internalInnerHtml]="passwordResetMessage.body" [userEventSource]="userEventSource"></div>
    </div>
    <div class="modal__footer">
      <a class="button button--secondary" (click)="openResetForm($event)">
        <i class="icon icon icon-ui-arrow--left"></i>
        <span>{{ (isSuccess ? "general.label.try_again" : "general.label.back") | translate }}</span>
      </a>
      <a *ngIf="!inputs?.alternateMode" class="button button--primary" (click)="closeModal(true, $event)">
        <span>{{ "general.label.close" | translate }}</span>
      </a>
      <a *ngIf="inputs?.alternateMode" class="button button--primary" (click)="back($event)">
        <span>{{ "user.label.back_to_login" | translate }}</span>
      </a>
    </div>
  </ng-container>
</div>

<ng-template #passwordTokenForm>
  <header class="modal__header">
    <h2 [ngStyle]="color && { color: 'black' }">{{ "user.label.cannot_login" | translate }}</h2>
    <a class="button button--transparent modal__button--close" (click)="closeModal(true)">
      <i class="icon icon-ui-close--sm" [ngStyle]="color && { 'background-color': '#' + color.color }"></i>
    </a>
  </header>
  <div class="modal__content">
    <div class="modal__text">
      <p>{{ "user.label.reset_information_needed" | translate }}</p>
    </div>
    <air-form
      #formComponent
      [controls]="form"
      [alternateReCaptchaActions]="[reCaptchaAction]"
      [userEventSource]="userEventSource"
      (submitted)="submitValues($event)"
    ></air-form>
  </div>
  <div>
    <div class="modal__footer" [ngClass]="{ 'modal__footer--standalone': standalone }">
      <a *ngIf="!standalone" class="button button--secondary" (click)="back($event)">
        <i class="icon icon-ui-arrow--left" [ngStyle]="color && { 'background-color': '#' + color.color }"></i>
        <span [ngStyle]="color && { color: '#' + color.color }">{{ "general.label.back" | translate }}</span>
      </a>
      <a
        type="button"
        (click)="submit($event)"
        class="button form__button button--cta"
        [airButtonLoading]="isSubmitting"
        [class.button--disabled]="formDisabled"
        [ngStyle]="color && { 'background-color': '#' + color.color }"
      >
        <span>{{ "general.label.send" | translate }}</span>
      </a>
    </div>
  </div>
</ng-template>
